module.exports = "/_next/static/images/DiagnoseDataQualityIssues@2x-66f2829d59d1916023ff4427bbd7161e.png";